import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "./Providers/ToastProvider";
import { AccountDeletionPage } from "./pages/AccountDeletion/AccountDeletionPage";
import { DCSQueryClient } from "./queryClient";

export const PublicApp = () => (
  <BrowserRouter>
    <ToastProvider>
      <QueryClientProvider client={DCSQueryClient}>
        <Routes>
          <Route path="/account-deletion" element={<AccountDeletionPage />} />
          <Route path="*" element={<Navigate to="/account-deletion" replace />} />
        </Routes>
      </QueryClientProvider>
    </ToastProvider>
  </BrowserRouter>
);

export default PublicApp;
